import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { alertCommentsQuery } from '@/queries/alert-comment.query'

export const Route = createFileRoute('/_dashboard/site/$id/alerts/edit/$alertId/comment/')({
  loader({ params, context: { queryClient } }) {
    return queryClient.ensureQueryData(alertCommentsQuery(params.alertId))
  },
  pendingComponent: PendingComponent,
})
